import React, { useState } from "react";
import { Heading, Button, Icon } from "@telia/teddy";
import cn from "classnames";
import "./ExpandableTextContainer.less";

type Props = {
    textBlocks?: {
        content: string;
        heading?: string;
        id?: string;
        type?: string;
    }[];
    whiteBg?: boolean;
};

const ExpandableTextContainer: React.FC<Props> = ({ textBlocks, whiteBg = false }) => {
    const [expanded, setExpanded] = useState(false);
    if (!textBlocks) {
        return null;
    }

    return (
        <div className="expandable-text-container">
            <div
                className={cn("expandable-text-container__textblockContainer", {
                    ["expandable-text-container__textblockContainer__expanded"]: expanded,
                })}
            >
                {textBlocks.map((block, index) => (
                    <div key={block.id || block.type || index} className="expandable-text-container__textblock">
                        {block.heading && (
                            <Heading as="h4" variant="title-200" mb="200">
                                {block.heading}
                            </Heading>
                        )}
                        {block.content && <div dangerouslySetInnerHTML={{ __html: block.content }} />}
                    </div>
                ))}
                <span className={cn({ ["gradient"]: !expanded, ["gradient__white"]: !expanded && whiteBg })}></span>
            </div>
            <div className="expandable-text-container__buttonContainer">
                <Button variant="text-underline" onClick={() => setExpanded(!expanded)} mt="200">
                    Les mer
                    <Icon name={expanded ? "chevron-up" : "chevron-down"} aria-hidden="true" focusable="false" />
                </Button>
            </div>
        </div>
    );
};

export default ExpandableTextContainer;
